import { Link as RouterLink } from 'react-router-dom'
import { IconButton } from '@mui/material'
import OutboundIcon from '@mui/icons-material/Outbound'

import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

export const RedirectButton = () => (
  <IconButton
    component={RouterLink}
    LinkComponent={RouterLink}
    to={joinAbsRoute(ROUTES.HEALTH_CHECK_EXTERNAL)}
  >
    <OutboundIcon width="30px" height="30px" color="primary" />
  </IconButton>
)
